module.exports = __webpack_public_path__ + "static/media/L.1b2e9cb3.jpg";